import { Game, eTextureAsset } from "../../../Game";
import { BgRingManager } from "./BgRingManager";
import { ParticlesEmitter as ParticlesEmitter } from "./Particles/ParticlesEmitter";
import { TIMER } from "../../Gameplay";
import { View } from "../View/View";
import { Player, ePlayerState } from "../Player/Player";
import { ScaleManager } from "../../../Utils/ScaleManager";



export class Background {
    /**
     * (RO) Staticky pristup
     */
    static get instance(): Background { return Background._instance; }
    private static _instance: Background;

    /**
     * Vrstva pro pozadi
     */
    get layer(): pc.Layer { return this._layer; }
    private _layer: pc.Layer;

    private _screen: pc.Entity;
    private _bg: pc.Entity;

    /**
     * Spravce prstencu
     */
    private _rings: BgRingManager;

    // Castice
    private _particles: ParticlesEmitter

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor() {
        Background._instance = this;

        // Vrstva pro pozadi
        this._layer = new pc.Layer({
            name: "background",
            clearDepthBuffer: false,
            clearColorBuffer: false,
            clearStencilBuffer: false,
            passThrough: true,
            opaqueSortMode: pc.SORTMODE_NONE,
            transparentSortMode: pc.SORTMODE_NONE
        });

        let layers = Game.app.scene.layers;
        let worldLayer = layers.getLayerByName("World");

        layers.insertTransparent(this._layer, layers.getOpaqueIndex(worldLayer));

        // 2D screen
        this._screen = new pc.Entity("bg");
        this._screen.addComponent(pc.eCompomentType.screen, {
            scaleMode: pc.SCALEMODE_NONE,
            screenSpace: true,
        });
        Game.app.root.addChild(this._screen);

        // Obrazek s pozadim
        let bg = this._bg = new pc.Entity();

        bg.addComponent(pc.eCompomentType.element, {
            type: pc.ELEMENTTYPE_IMAGE,
            anchor: [0, 0, 0, 0],
            pivot: [0, 0],
            textureAsset: Game.app.assets.find(eTextureAsset.background, pc.ASSET_TEXTURE),
            layers: [this._layer.id]
        });
        this._screen.addChild(bg);

        // Prstence
        this._rings = new BgRingManager();

        // Castice
        this._particles = new ParticlesEmitter(Game.app.root);
        this._particles.init({
            emitOffset: new pc.Vec3(0, -4.5, -30),
            emitMinInterval: 600,
            emitMaxInterval: 600,
            emitTimer: TIMER,
            endOffsetZ: -4
        }, {
            partColor: new pc.Color(1, 1, 1),
            partMinAngle: -225,
            partMaxAngle: 45,
            partSpacingVolitionRatio: 0.25,
            radius: 4,
            partMinCnt: 20,
            partMaxCnt: 30,
            partMinLen: 0.2,
            partMaxLen: 4,
            partWidth: 0.05,
            entityMaxDepth: 8,
            rotMinSpeed: 0,
            rotMaxSpeed: 0,
            moveMinSpeed: 6,
            moveMaxSpeed: 9,
            rndRotation: false
        });

        Game.app.on(ScaleManager.EVENT_RESIZE, this.handleGameSizeChange, this);
        this.handleGameSizeChange(Game.scale.width, Game.scale.height);
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    reset(): void {
        this._rings.reset();
        this._particles.reset();
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    update(): void {
        this._rings.update();

        if (Player.instance.state != ePlayerState.idle)
            this._particles.update(View.instance.cameraPos);
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private handleGameSizeChange(w: number, h: number): void {
        this._bg.element.width = w;
        this._bg.element.height = h;
    }
}